import {IIngredientModel, IIngredients, IngredientProtocol} from '@/modules/ingredients/IIngredientModel';
import {BaseModel} from '@/core/standard/BaseModel';
import IngredientService from '@/modules/ingredients/IngredientService';

const ingredient = {
  name: '',
  price: 1,
  old_price: null,
  description: '',
  image: '',
  serial: '',
  is_active: true,
  unit : '',
  min_stock: '',
  tendency: '',
  units_list: [],
  iva: 0,
  sku: '',
};

class IngredientModel extends BaseModel<IIngredientModel, IngredientProtocol> {
  public modelName = 'Ingredientes';
  public request = 'FormData';

  constructor() {
    super(ingredient, IngredientService);
  }

  public async save(toast, toastConfig): Promise<any> {
    const formData = new FormData();
    Object.keys(ingredient).forEach((field) => {
      if (this[field] !== null && this[field] !== undefined) {
        if (typeof this[field] === 'object' && !(this[field] instanceof File)) {
          formData.append(field, JSON.stringify(this[field]));
        } else {
          const splittedField = field.split('_');
          const lang = localStorage.getItem('lang') || 'es';
          if (splittedField.pop() !== lang) {
            formData.append(field, this[field]);
          }
        }
      }
    });
    if (!formData.get('image')) {
      if (!formData.has('image')) {
        formData.append('image', '');
      }
    } else if (formData.has('image') && !(formData.get('image') instanceof File)) {
      formData.delete('image');
    }
    // @ts-ignore
    if (!this.min_stock) {
      formData.set('min_stock', '0');
    }
    // @ts-ignore
    if (this.id) {
      // @ts-ignore
      formData.append('id', this.id);
      return this.update(formData, toast, toastConfig);
    } else {
      return this.create(formData, toast, toastConfig);
    }
  }

  public async getIngredientsFile(protocol: IngredientProtocol) {
    return await IngredientService.downloadIngredientsFile({
      method: 'GET',
      query: protocol,
      headers: {Accept: '*/*'},
      responseType: 'blob',
    });
  }
}

export default IngredientModel as new () => IIngredients;
